import LyraAuth from './LyraAuth'
// Inject css in header
// TODO default style to make more extensible
import './LyraAuth.css'
import './utils/Animation.css'

export default LyraAuth
